import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
    Breadcrumb, Card, Col, Spin,
} from 'antd';
import GroupForm from './components/GroupForm';
import GroupModules from './components/GroupModules';
import { getGroupsListRequest } from '../User_group/redux/actions/get_groups_list.actions';

const mapStateToProps = (state) => {
    const { groupsList, loading } = state.UserManagement.User_group.User_group_list;
    const { moduleOptionFields, loading: loading_update, count } = state.UserManagement.User_group_update;
    return {
        groupsList, loading, moduleOptionFields, loading_update, count,
    };
}; const
    BreadcrumbItem = Breadcrumb.Item;

export default connect(mapStateToProps, null)(class EditGroup extends Component {
    componentDidMount() {
        this.props.dispatch(getGroupsListRequest(this.props.location.pathname.slice(-24)));
    }

    componentWillUnmount() {
        this.props.dispatch({ type: 'RESET_GROUP_UPDATE_MODULES' });
    }

    render() {
        const { count, moduleOptionFields, loading_update } = this.props;
        return (
            <Spin
                style={{ position: 'fixed' }}
                spinning={loading_update}
                tip={count > 1 ? `Updated ${count} of ${moduleOptionFields && moduleOptionFields.size} fields` : 'Loading ...'}
            >
                <div className="user-group-container">
                    <Breadcrumb style={{ marginBottom: '1%' }}>
                        <BreadcrumbItem><Link to="/UserManagement/User_group">Group Management</Link></BreadcrumbItem>
                        <BreadcrumbItem>Edit Group</BreadcrumbItem>
                    </Breadcrumb>
                    <Col span={24}>
                        <Card className="bordersShadows" style={{ paddingTop: '1%' }}>
                            {!this.props.loading && <GroupForm loading={this.props.loading} groupsList={this.props.groupsList && this.props.groupsList[0]} />}
                            <h4 className="page-title width100">Module permissions</h4>
                            <p className="title_permissions_position">Edit the permissions of this group.</p>
                            <GroupModules groupId={this.props.location.pathname.slice(-24)} />
                        </Card>
                    </Col>
                </div>
            </Spin>
        );
    }
});



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_update/index.js